"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as n, Fragment as A, jsxs as I } from "react/jsx-runtime";
import * as u from "react";
import K from "classnames";
import { useIsInverseVariant as M } from "./theme-variant-context.js";
import { applyCssVars as v, pxToRem as c } from "./utils/css.js";
import { getPrefixedDataAttributes as q } from "./utils/dom.js";
import { useTheme as m } from "./hooks.js";
import { vars as a } from "./skins/skin-contract.css-mistica.js";
import { text as G, withWordBreak as J, withoutWordBreak as Q, truncate as U, truncateToOneLine as X, vars as p } from "./text.css-mistica.js";
import { VIVO_NEW_SKIN as Y } from "./skins/constants.js";
import Z from "./screen-reader-only.js";
const $ = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
}, ee = (e)=>e === !0 ? 1 : e || "initial", d = "Ħ", te = /* @__PURE__ */ I(A, {
    children: [
        /* @__PURE__ */ n("span", {
            "aria-hidden": !0,
            children: d
        }),
        /* @__PURE__ */ n(Z, {
            children: /* @__PURE__ */ n("span", {
                children: "Vivo"
            })
        })
    ]
}), ie = (e)=>u.Children.map(e, (t)=>typeof t != "string" || !t.includes(d) ? t : /* @__PURE__ */ n(A, {
            children: t.split(d).map((i, r)=>/* @__PURE__ */ I(u.Fragment, {
                    children: [
                        r > 0 && te,
                        i
                    ]
                }, r))
        })), o = (param)=>{
    let { weight: e, color: t = a.colors.textPrimary, decoration: i, truncate: r, transform: g, wordBreak: b = !0, hyphens: T = "auto", as: S = "span", children: l, size: f, mobileSize: k = f, desktopSize: H = f, lineHeight: L, mobileLineHeight: w = L, desktopLineHeight: z = L, letterSpacing: P, textAlign: V, textShadow: y, id: C, role: W, "aria-level": R, dataAttributes: N } = param;
    const { skinName: E } = m(), F = M(), O = ee(r), _ = {
        [a.colors.textPrimary]: a.colors.textPrimaryInverse,
        [a.colors.textSecondary]: a.colors.textSecondaryInverse,
        [a.colors.textLink]: a.colors.textLinkInverse,
        [a.colors.textError]: a.colors.textErrorInverse
    };
    if (!l && l !== 0) return null;
    const j = K(G, b ? J : Q, {
        [U]: r,
        [X]: r === 1 || r === !0
    }), D = v({
        [p.mobileSize]: k ? c(k) : "inherit",
        [p.mobileLineHeight]: w ? c(w) : "inherit",
        [p.desktopSize]: H ? c(H) : "inherit",
        [p.desktopLineHeight]: z ? c(z) : "inherit"
    }), B = r ? v({
        [p.lineClamp]: String(O)
    }) : {};
    var __t;
    return /*#__PURE__*/ u.createElement(S, _object_spread_props(_object_spread({
        className: j,
        id: C,
        role: W,
        "aria-level": R
    }, q(N, "Text")), {
        style: _object_spread_props(_object_spread({}, D, B), {
            hyphens: T,
            WebkitHyphens: T,
            letterSpacing: P,
            fontWeight: e ? $[e] : "inherit",
            textTransform: g || "inherit",
            textDecoration: i !== null && i !== void 0 ? i : "inherit",
            overflowWrap: b ? "anywhere" : "inherit",
            color: F ? (__t = _[t]) !== null && __t !== void 0 ? __t : t : t,
            textAlign: V,
            textShadow: y,
            // When rendering as <pre/>, spaces are preserved and we don't want to remove them
            whiteSpace: S === "pre" ? void 0 : "pre-line"
        })
    }), E === Y ? ie(l) : l);
}, h = (e)=>{
    if (e.light) return "light";
    if (e.regular) return "regular";
    if (e.medium) return "medium";
    if (e.weight) return e.weight;
}, s = (param)=>{
    let { forceMobileSizes: e, mobileSize: t, mobileLineHeight: i, desktopSize: r, desktopLineHeight: g } = param;
    return e ? {
        size: t,
        lineHeight: i
    } : {
        mobileSize: t,
        mobileLineHeight: i,
        desktopSize: r,
        desktopLineHeight: g
    };
}, x = {
    text1: {
        mobileSize: 12,
        mobileLineHeight: "16px",
        desktopSize: 14,
        desktopLineHeight: "20px"
    },
    text2: {
        mobileSize: 14,
        mobileLineHeight: "20px",
        desktopSize: 16,
        desktopLineHeight: "24px"
    },
    text3: {
        mobileSize: 16,
        mobileLineHeight: "24px",
        desktopSize: 18,
        desktopLineHeight: "24px"
    },
    text4: {
        mobileSize: 18,
        mobileLineHeight: "24px",
        desktopSize: 20,
        desktopLineHeight: "28px"
    },
    text5: {
        mobileSize: 20,
        mobileLineHeight: "24px",
        desktopSize: 28,
        desktopLineHeight: "32px"
    },
    text6: {
        mobileSize: 24,
        mobileLineHeight: "32px",
        desktopSize: 32,
        desktopLineHeight: "40px"
    },
    text7: {
        mobileSize: 28,
        mobileLineHeight: "32px",
        desktopSize: 40,
        desktopLineHeight: "48px"
    },
    text8: {
        mobileSize: 32,
        mobileLineHeight: "40px",
        desktopSize: 48,
        desktopLineHeight: "56px"
    },
    text9: {
        mobileSize: 40,
        mobileLineHeight: "48px",
        desktopSize: 56,
        desktopLineHeight: "64px"
    },
    text10: {
        mobileSize: 48,
        mobileLineHeight: "56px",
        desktopSize: 64,
        desktopLineHeight: "72px"
    }
}, he = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: r } = m();
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text10))), {
        weight: r.text10.weight,
        dataAttributes: _object_spread({
            "component-name": "Text10"
        }, e)
    }), i));
}, ge = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: r } = m();
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text9))), {
        weight: r.text9.weight,
        dataAttributes: _object_spread({
            "component-name": "Text9"
        }, e)
    }), i));
}, ue = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: r } = m();
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text8))), {
        weight: r.text8.weight,
        dataAttributes: _object_spread({
            "component-name": "Text8"
        }, e)
    }), i));
}, de = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: r } = m();
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text7))), {
        weight: r.text7.weight,
        dataAttributes: _object_spread({
            "component-name": "Text7"
        }, e)
    }), i));
}, be = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: r } = m();
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text6))), {
        weight: r.text6.weight,
        dataAttributes: _object_spread({
            "component-name": "Text6"
        }, e)
    }), i));
}, Te = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: r } = m();
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text5))), {
        weight: r.text5.weight,
        dataAttributes: _object_spread({
            "component-name": "Text5"
        }, e)
    }), i));
}, Se = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text4))), {
        weight: h(i),
        dataAttributes: _object_spread({
            "component-name": "Text4"
        }, e)
    }), i));
}, fe = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text3))), {
        weight: h(i),
        dataAttributes: _object_spread({
            "component-name": "Text3"
        }, e)
    }), i));
}, ke = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text2))), {
        weight: h(i),
        dataAttributes: _object_spread({
            "component-name": "Text2"
        }, e)
    }), i));
}, He = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: t } = _param, i = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ n(o, _object_spread(_object_spread_props(_object_spread({}, s(_object_spread({
        forceMobileSizes: t
    }, x.text1))), {
        weight: h(i),
        dataAttributes: _object_spread({
            "component-name": "Text1"
        }, e)
    }), i));
}, Le = o;
export { o as Text, He as Text1, he as Text10, ke as Text2, fe as Text3, Se as Text4, Te as Text5, be as Text6, de as Text7, ue as Text8, ge as Text9, Le as default, $ as mapToWeight, x as textProps };
